export default Object.freeze({
  BACKEND_URL: {
    LOCAL: "http://localhost:9001",
    DEV: "https://mentostar-api.applore.in",
    PRODUCTION: "https://api.mentostar.com",
  },
  ENV: "dev",
});
